<template>
  <div class="app-container">
    <el-tabs v-model="active" @tab-click="handleClick" type="card" class="cardTabs">
      <el-tab-pane label="充值流水" name="0"></el-tab-pane>
      <el-tab-pane label="消费流水" name="1"></el-tab-pane>
      <el-tab-pane label="退款流水" name="2"></el-tab-pane>
      <el-tab-pane label="赠送金额流水" name="3"></el-tab-pane>
      <el-tab-pane label="扣费流水" name="4"></el-tab-pane>
      <el-tab-pane label="增值缴费流水" name="5"></el-tab-pane>
    </el-tabs>
    <list ref="list" v-if="active==0">
      <template slot="toolbar-right" v-if="!isMB">
        <el-button size="small" class="filter-item" @click="onExport('list')" type="primary" plain>导出</el-button>
      </template>
      <template slot="column">
        <el-table-column label="退款" min-width="140px">
          <template slot-scope="{row}">
            <span v-if="row.RefundStatus===0">待退款(￥{{row.RefundAmount||0}})</span>
            <span v-else-if="row.RefundStatus==1">退款成功(￥{{row.RefundAmount||0}})</span>
            <span v-else-if="row.RefundStatus==2">退款失败(￥{{row.RefundAmount||0}})</span>
            <!-- <el-button type="text" v-if="row.Channel==1 && row.RefundFlowId==0 && $permission.canWrite()" @click="toRefund(row)"
             :style="row.RefundStatus===null?'':'margin-left:5px;'">退款</el-button> -->
          </template>
        </el-table-column>
      </template>
    </list>
    <list2 ref="list2" v-if="active==1">
      <template slot="toolbar-right" v-if="!isMB">
        <el-button size="small" class="filter-item" @click="onExport('list2')" type="primary" plain>导出</el-button>
      </template>
    </list2>
    <list3 ref="list3" v-if="active==2">
      <template slot="toolbar-right" v-if="!isMB">
        <el-button v-if="$permission.can('退款')" size="small" type="success" class="filter-item" @click="importRefundFile1" plain>导入微信退款</el-button>
        <el-button v-if="$permission.can('退款')" size="small" type="success" class="filter-item" @click="importRefundFile2" plain>导入线下退款</el-button>
        <el-button size="small" class="filter-item" @click="onExport('list3')" type="primary" plain>导出</el-button>
      </template>
    </list3>
    <list4 ref="list4" v-if="active==3">
      <template slot="toolbar-right" v-if="!isMB">
        <el-button size="small" class="filter-item" @click="onExport('list4')" type="primary" plain>导出</el-button>
      </template>
    </list4>
    <list5 ref="list5" v-if="active==4">
      <template slot="toolbar-right" v-if="!isMB">
        <el-button size="small" class="filter-item" @click="onExport('list5')" type="primary" plain>导出</el-button>
      </template>
    </list5>
    <list6 ref="list6" v-if="active==5">
      <template slot="toolbar-right" v-if="!isMB">
        <el-button size="small" class="filter-item" @click="onExport('list6')" type="primary" plain>导出</el-button>
      </template>
    </list6>
    <refund-dialog ref="refundDialog" @close-saved="handleClick" />
    <import-refund-2 ref="importRefund2" @upload-success="handleClick" />
    <import-refund-1 ref="importRefund1" @upload-success="handleClick" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/consume/turnover/list";
import list2 from "@/components/consume/turnover/list2";
import list3 from "@/components/consume/turnover/list3";
import list4 from "@/components/consume/turnover/list4";
import list5 from "@/components/consume/turnover/list5";
import list6 from "@/components/consume/turnover/list6";
import refundDialog from "@/components/consume/turnover/refundDialog";
import importRefund1 from "@/components/consume/turnover/importRefund1";
import importRefund2 from "@/components/consume/turnover/importRefund2";
export default {
  name: "turnover",
  mixins: [curdMixins],
  components: {
    list,
    list2,
    list3,
    list4,
    list5,
    list6,
    refundDialog,
    importRefund1,
    importRefund2
  },
  data() {
    return {
      active: "0",
      isMB: this.$store.state.isMB,
    }
  },
  methods: {
    onExport(name) {
      this.$refs[name].export();
    },
    toRefund(row) {
      this.$refs.refundDialog.openEdit(row);
    },
    handleClick(e) {
      setTimeout(() => {
        if(this.active=='0') {
          this.$refs.list.getData();
        } else if(this.active=='1') {
          this.$refs.list2.getData();
        } else if(this.active=='2') {
          this.$refs.list3.getData();
        } else if(this.active=='3') {
          this.$refs.list4.getData();
        } else if(this.active=='4') {
          this.$refs.list5.getData();
        } else {
          this.$refs.list6.getData();
        }
      }, 200);
    },
    importRefundFile1() {
      this.$refs.importRefund1.open({ GroupId: 0 });
    },
    importRefundFile2() {
      this.$refs.importRefund2.open({ GroupId: 0 });
    },
  },
};
</script>